import type { EstimationMethod } from '@/constants/ai-assistant/estimation-method';
import type { ProjectWorkflowPosition } from '@/types/ai-assistant/steps';
import type { ProjectWorkflowDefinitionsDTO, ProjectWorkflowDTO } from '@/types/api/project-workflow';

type ProjectWorkflowData = ProjectWorkflowDTO['data'];
type ParametricData = NonNullable<ProjectWorkflowData['parametric']>;

export function useProjectWorkflowStates() {
    const projectHistoryId = useState<number | undefined>('project-workflow-project-history-id');
    const estimationMethod = useState<EstimationMethod | undefined>('project-workflow-estimation-method');
    const workflowDefinitions = useState<ProjectWorkflowDefinitionsDTO | undefined>('project-workflow-definitions');
    const workflowDefinitionHash = useState<string | undefined>('project-workflow-definition-hash');
    const currentPosition = useState<ProjectWorkflowPosition | undefined>('project-workflow-current-position');
    const workflowNodes = useState<ProjectWorkflowDTO['nodes']>('project-workflow-nodes', () => []);
    const access = useState<ProjectWorkflowDTO['access'] | undefined>('project-workflow-access');
    const projectBasics = useState<ProjectWorkflowData['projectBasics'] | undefined>('project-workflow-project-basics');
    const constructionCategory = useState<ParametricData['constructionCategory'] | undefined>(
        'project-workflow-construction-category'
    );
    const scopeProgram = useState<ParametricData['scopeProgram'] | undefined>('project-workflow-scope-program');
    const markupsContingency = useState<ParametricData['markupsContingency'] | undefined>(
        'project-workflow-markups-contingency'
    );
    const estimate = useState<ParametricData['estimate'] | undefined>('project-workflow-estimate');
    const supplementalData = useState<ProjectWorkflowDTO['supplementalData'] | undefined>(
        'project-workflow-supplemental-data'
    );
    const requestCount = useState('project-workflow-request-count', () => 0);
    const workflowChangeCount = useState('project-workflow-change-count', () => 0);
    const loadVersion = useState('project-workflow-load-version', () => 0);
    const errorMessage = useState<string | undefined>('project-workflow-error', () => undefined);

    return {
        projectHistoryId,
        estimationMethod,
        workflowDefinitions,
        workflowDefinitionHash,
        currentPosition,
        workflowNodes,
        access,
        projectBasics,
        constructionCategory,
        scopeProgram,
        markupsContingency,
        estimate,
        supplementalData,
        requestCount,
        workflowChangeCount,
        loadVersion,
        errorMessage
    };
}
